(() => {
  const bindCarousels = () => {
    document.querySelectorAll('[data-nqc-carousel]:not([data-nqc-bound])').forEach((track) => {
      track.setAttribute('data-nqc-bound', '1');
      const card = track.closest('.nqc-card');
      const dots = card ? [...card.querySelectorAll('.nqc-card__dot')] : [];
      const nextBtn = card ? card.querySelector('[data-nqc-next]') : null;

      const sync = () => {
        const w = track.clientWidth || 1;
        const i = Math.round(track.scrollLeft / w);
        dots.forEach((d, idx) => d.classList.toggle('nqc-card__dot--on', idx === i));
        if (nextBtn) {
          const atEnd = track.scrollLeft + w >= track.scrollWidth - 4;
          nextBtn.setAttribute('aria-label', atEnd ? 'Previous photo' : 'Next photo');
          nextBtn.dataset.dir = atEnd ? 'prev' : 'next';
          nextBtn.style.transform = atEnd ? 'translateY(-50%) rotate(180deg)' : 'translateY(-50%)';
        }
      };

      track.addEventListener('scroll', sync, { passive: true });
      sync();

      if (nextBtn && !nextBtn.dataset.bound) {
        nextBtn.dataset.bound = '1';
        nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const w = track.clientWidth || 1;
          const dir = nextBtn.dataset.dir === 'prev' ? -1 : 1;
          track.scrollBy({ left: dir * w, behavior: 'smooth' });
        });
      }
    });
  };

  const bindSwatches = () => {
    document.querySelectorAll('[data-nqc-sw]').forEach((row) => {
      if (row.dataset.bound) return;
      row.dataset.bound = '1';
      row.addEventListener('click', (e) => {
        const sw = e.target.closest('.nqc-card__sw');
        if (!sw) return;
        e.preventDefault();
        e.stopPropagation();
        row.querySelectorAll('.nqc-card__sw').forEach((s) => s.classList.remove('is-on'));
        sw.classList.add('is-on');
        const name = row.querySelector('[data-nqc-sw-name]');
        if (name) name.textContent = sw.getAttribute('data-sw-name') || '';
        const img = sw.getAttribute('data-sw-img');
        if (img) {
          const first = row.closest('.nqc-card')?.querySelector('.nqc-card__img');
          if (first) first.src = img;
        }
      });
    });
  };

  const bindXsell = () => {
    document.querySelectorAll('[data-xs-slider]:not([data-xs-bound])').forEach((slider) => {
      slider.setAttribute('data-xs-bound', '1');
      const track = slider.querySelector('[data-xs-track]');
      const prev = slider.querySelector('[data-xs-prev]');
      const next = slider.querySelector('[data-xs-next]');
      if (!track) return;

      const step = () => {
        const card = track.querySelector('.nqc-card');
        if (!card) return Math.max(240, track.clientWidth * 0.8);
        const gap = parseFloat(getComputedStyle(track).gap) || 14;
        return card.getBoundingClientRect().width + gap;
      };

      const sync = () => {
        const max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        const canScroll = max > 4;
        if (prev) prev.style.display = canScroll ? '' : 'none';
        if (next) next.style.display = canScroll ? '' : 'none';
      };

      if (prev) {
        prev.addEventListener('click', () => {
          track.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', () => {
          track.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  };

  const init = () => {
    bindCarousels();
    bindSwatches();
    bindXsell();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
